import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
    MovieOnlineStreamsFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getFilmOtt } from './get-film-ott';

export function getFilmOnlineStreams(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null
): MovieOnlineStreamsFragment | undefined {
    return (filmOrVideo && getFilmOtt(filmOrVideo)?.onlineStreams) || undefined;
}
